export default "__VITE_ASSET__DaJzi_NB__"